export const AUTHENTICATE_FAILURE = 'AUTHENTICATE_FAILURE';

export const authenticateFailure = (payload: Error) => ({
    type: AUTHENTICATE_FAILURE,
    payload,
});
